import React from 'react';
import { IconWrapper, LabelWrapper, FilterColLabelText } from '../filter-item/filter-item.styled';
export const FilterShowMoreItem = ({
  label,
  icon,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(LabelWrapper, rest, icon && /*#__PURE__*/React.createElement(IconWrapper, null, icon), /*#__PURE__*/React.createElement(FilterColLabelText, null, label));
};